

// === TYPEOFBUSINESS ===
//predefalerttime: N .. alert before event, predefined, in days, default = 2 days
//predefreturntime: N .. returning customers should return after N days (indictor if longer)
//predefctags: .. customer classification tags 
export const typesOfBusiness = [
    {
        id: '1',
        name: 'Hair Salon',
        alerttime: 2,  //..alert before event, predefined, in days, default = 2 days
        returntime: 30, //.. returning customers should return after N days (indictor if longer)
        ctags: ['longhair', 'beard', 'blond'],       //..cust class tags 'longhair', 'beard', ...
    },
    {
        id: '2',
        name: 'Barber Shop',
        alerttime: 2,  //..alert before event, predefined, in days, default = 2 days
        returntime: 20, //.. returning customers should return after N days (indictor if longer)
        ctags: ['fullbeard', 'stylish', 'modern', 'traditional'],       //..cust class tags 'longhair', 'beard', ...
    },
    {
        id: '3',
        name: 'Beauty Salon',
        alerttime: 1,  //..alert before event, predefined, in days, default = 2 days
        returntime: 15,
        ctags: ['skin', 'nail', 'cosmetic'],       //..cust class tags 'longhair', 'beard', ...
    },
    {
        id: '4',
        name: 'Car Repair',
        alerttime: 2,  //..alert before event, predefined, in days, default = 2 days
        returntime: 180,
        ctags: ['suv', 'sport', 'family', 'petrol', 'diesel'],       //..cust class tags 'longhair', 'beard', ...
    },
    {
        id: '99',
        name: 'Other / Default',
        alerttime: 1,  //..alert before event, predefined, in days, default = 2 days
        returntime: 30,
        ctags: ['remind', 'value', 'returning', 'nice', 'complaining'],       //..cust class tags 'longhair', 'beard', ...
    },

  ]


  export const SegGroups = [
    {id:1, name:"Gold",   custclass: 4}, //Zlatí zákazníci
    {id:2, name:"Silver", custclass: 3}, //Strieborní zákazníci
    {id:3, name:"Bronze", custclass: 2},  //Bronzoví zákazníci
    {id:4, name:"Potato", custclass: 1} //Zemiakoví zákazníci
  ]

  export const ListOfChannels = [
    {id: '1', type: 'email', displayName: 'Email', class: 'fas fa-envelope'},
    {id: '2', type: 'phone', displayName: 'Phone', class: 'fas fa-phone'},
    {id: '3', type: 'facebook', displayName: 'Facebook', class: 'fab fa-facebook'},
    {id: '4', type: 'skype', displayName: 'Skype', class: 'fab fa-skype'},
    {id: '5', type: 'twitter', displayName: 'Twitter', class: 'fab fa-twitter'},
    {id: '6', type: 'address', displayName: 'Address', class: 'fab fa-address'},
    {id: '7', type: 'other', displayName: 'Other', class: 'fas fa-bookmark'},
    

  ]

